module.exports = ".loading {\n  position: absolute;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 100vh;\n  width: 100vw;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #fff;\n  color:black;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/callback/callback.component.css
// module id = ./src/app/callback/callback.component.css
// module chunks = main